'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Base,
    IframeRuntime,
    boundMethodCheck = function boundMethodCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new Error('Bound instance method accessed before binding');
  }
};

Base = require('./base');

IframeRuntime = function (_Base) {
  _inherits(IframeRuntime, _Base);

  function IframeRuntime(definition) {
    _classCallCheck(this, IframeRuntime);

    var _this = _possibleConstructorReturn(this, (IframeRuntime.__proto__ || Object.getPrototypeOf(IframeRuntime)).call(this, definition));

    _this.updateIframe = _this.updateIframe.bind(_this);
    // Called every time the iframe has loaded successfully
    _this.onLoaded = _this.onLoaded.bind(_this);
    _this.onMessage = _this.onMessage.bind(_this);
    _this.origin = window.location.origin;
    _this.connecting = false;
    _this.connected = false;
    _this.buffer = [];
    _this.iframe = null;
    return _this;
  }

  _createClass(IframeRuntime, [{
    key: 'getElement',
    value: function getElement() {
      return this.iframe;
    }
  }, {
    key: 'isConnected',
    value: function isConnected() {
      return this.connected;
    }
  }, {
    key: 'setMain',
    value: function setMain(graph) {
      if (this.graph) {
        // Unsubscribe from previous main graph
        this.graph.removeListener('changeProperties', this.updateIframe);
      }
      if (!graph) {
        return _get(IframeRuntime.prototype.__proto__ || Object.getPrototypeOf(IframeRuntime.prototype), 'setMain', this).call(this, graph);
      }
      // Update contents on property changes
      graph.on('changeProperties', this.updateIframe);
      _get(IframeRuntime.prototype.__proto__ || Object.getPrototypeOf(IframeRuntime.prototype), 'setMain', this).call(this, graph);
      // Ensure iframe gets updated
      this.updateIframe();
    }
  }, {
    key: 'setParentElement',
    value: function setParentElement(parent) {
      this.iframe = document.createElement('iframe');
      this.iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-forms');
      return parent.appendChild(this.iframe);
    }
  }, {
    key: 'connect',
    value: function connect() {
      if (!this.iframe) {
        throw new Error('Unable to connect without a parent element');
      }
      this.iframe.addEventListener('load', this.onLoaded, false);
      // Let the UI know we're connecting
      this.connecting = true;
      this.emit('status', {
        online: false,
        label: 'connecting'
      });
      // Set the source to the iframe so that it can load
      this.iframe.setAttribute('src', this.getAddress());
      // Set an ID for targeting purposes
      this.iframe.id = 'preview-iframe';
      // Start listening for messages from the iframe
      return window.addEventListener('message', this.onMessage, false);
    }
  }, {
    key: 'updateIframe',
    value: function updateIframe() {
      var env;
      boundMethodCheck(this, IframeRuntime);
      if (!this.iframe || !this.graph) {
        return;
      }
      env = this.graph.properties.environment;
      if (!env || !env.content) {
        return;
      }
      return this.send('iframe', 'setcontent', env.content);
    }
  }, {
    key: 'disconnect',
    value: function disconnect() {
      if (this.iframe) {
        this.iframe.removeEventListener('load', this.onLoaded, false);
      }
      this.connected = false;
      // Stop listening to messages
      window.removeEventListener('message', this.onMessage, false);
      this.emit('status', {
        online: false,
        label: 'disconnected'
      });
      return this.emit('disconnected');
    }
  }, {
    key: 'onLoaded',
    value: function onLoaded() {
      var _this2 = this;

      var timeout;
      boundMethodCheck(this, IframeRuntime);
      // Since the iframe runtime runs in user's browser, being loaded doesn't
      // necessarily mean that the runtime has started. Especially on slower
      // mobile devices the runtime initialization can still take a while.
      // Because of this we loop requesting runtime info until runtime
      // responds and only then consider ourselves connected.
      this.once('capabilities', function () {
        if (timeout) {
          // Runtime responded with a capabilities message. We're live!
          clearTimeout(timeout);
        }
        _this2.connecting = false;
        _this2.connected = true;
        _this2.emit('status', {
          online: true,
          label: 'connected'
        });
        _this2.emit('connected');
        _this2.updateIframe();
        return _this2.flush();
      });
      // Start requesting capabilities
      this.postMessage('runtime', 'getruntime', {});
      return timeout = setTimeout(function () {
        // Keep trying until runtime responds
        return _this2.postMessage('runtime', 'getruntime', {});
      }, 500);
    }
  }, {
    key: 'send',
    value: function send(protocol, command, payload) {
      if (this.connecting) {
        this.buffer.push({
          protocol: protocol,
          command: command,
          payload: payload
        });
        return;
      }
      return this.postMessage(protocol, command, payload);
    }
  }, {
    key: 'postMessage',
    value: function postMessage(protocol, command, payload) {
      var e, w;
      w = this.iframe.contentWindow;
      if (!w) {
        return;
      }
      try {
        if (w.location.href === 'about:blank') {
          return;
        }
        if (w.location.href.indexOf('chrome-extension://') !== -1) {
          throw new Error('Use * for IFRAME communications in a Chrome app');
        }
      } catch (error) {
        e = error;
        // Chrome Apps
        w.postMessage(JSON.stringify({
          protocol: protocol,
          command: command,
          payload: payload
        }), '*');
        return;
      }
      return w.postMessage(JSON.stringify({
        protocol: protocol,
        command: command,
        payload: payload
      }), w.location.href);
    }
  }, {
    key: 'onMessage',
    value: function onMessage(message) {
      var data;
      boundMethodCheck(this, IframeRuntime);
      if (message.source && message.source !== this.iframe.contentWindow) {
        return;
      }
      // Message from unrelated source
      if (typeof message.data === 'string') {
        data = JSON.parse(message.data);
      } else {
        data = message.data;
      }
      return this.recvMessage(data);
    }
  }, {
    key: 'flush',
    value: function flush() {
      var i, item, len, ref;
      ref = this.buffer;
      for (i = 0, len = ref.length; i < len; i++) {
        item = ref[i];
        this.postMessage(item.protocol, item.command, item.payload);
      }
      return this.buffer = [];
    }
  }]);

  return IframeRuntime;
}(Base);

module.exports = IframeRuntime;